import { render } from "./PasswordReset.vue?vue&type=template&id=df694cde&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=df694cde&scoped=true&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df694cde"]])

export default __exports__